const IMAGE_PATH = "/assets/img/";
const NO_JOB_ID_VALUE = "-";
const RECOMMEND_LIST = {
    SUGGESTION: {
        0: IMAGE_PATH + "img_011.svg",
        1: IMAGE_PATH + "img_012.svg",
    },
    SUGGESTION_TYPE: {
        0: IMAGE_PATH + "img_021.svg",
        1: IMAGE_PATH + "img_022.svg",
        2: IMAGE_PATH + "img_023.svg",
        3: IMAGE_PATH + "img_024.svg",
    },
    ANALYSIS_TYPE: {
        0: IMAGE_PATH + "img_001.svg",
        1: IMAGE_PATH + "img_002.svg",
        2: IMAGE_PATH + "img_003.svg",
    },
};

const RECOMMEND_ICON_TOOLTIP = {
    SUGGESTION: {
        0: "icon_recommendation",
        1: "icon_analysis",
    },
    SUGGESTION_TYPE: {
        0: "icon_operation",
        1: "icon_machine",
        2: "icon_material",
        3: "icon_method",
    },
    ANALYSIS_TYPE: {
        0: "icon_preparation_time",
        1: "icon_running_time",
        2: "icon_downtime",
    },
};


const RECOMMEND_LIST_DEFAULT_NUMBER = 4;

const MACHINE_EVENT = {
    PAPER_JAMS: "paperJams",
    PAPER_EMPTY: "paperEmpty",
    TRAY_FULL: "trayFull",
    SERVICE_CALL: "serviceCall",
    TONER_EMPTY: "tonerEmpty",
    OTHER_TRANSPORT_ERROR: "otherTransportError",
    ADJUSTMENT: "adjustment",
}

const LOG_STATUS_VALUE = {
    NORMAL :'normal',
    NO_LOG :'noLog',
    UNUSED_LOG :'unusedLog',
}

const IMAGE_DETECTION_SCORE_TABLE_COLUMN = {
    SERIAL_NUMBER: "serial_number",
    LOCAL_DATE_TIME: "local_date_time",
    SCORE_RAW_MINIMUM: "score_raw_minimum",
    SCORE_FEATURE_NAME: "score_feature_name",
    SCORE_AVERAGE: "score_average",
    SCORE_AQA_AVERAGE: "score_aqa_average"
}

const AQACONSTANTS={
    AVERAGE_DURATION:28
  }

module.exports = {
    RECOMMEND_LIST,
    RECOMMEND_LIST_DEFAULT_NUMBER,
    RECOMMEND_ICON_TOOLTIP,
    MACHINE_EVENT,
    NO_JOB_ID_VALUE,
    LOG_STATUS_VALUE,
    IMAGE_DETECTION_SCORE_TABLE_COLUMN,
    AQACONSTANTS
};
